import Axios from 'axios';

const isDevelopment = process.env.NODE_ENV === 'development';
export const axiosInstance = Axios.create({
  baseURL: isDevelopment ? null : process.env.BASE_URL,
  browserBaseURL: isDevelopment ? null : process.env.BASE_URL,
  proxy: isDevelopment // enable proxy only for local development
});
